import { useState } from 'react';
import { Addon, Plan, UserInfo, UserServiceConfiguration } from 'AppTypes';
import { Button } from './components/button';
import { Sidebar } from './components/sidebar';
import { PersonalInfo } from './components/personalInfo';
import { SelectPlan } from './components/selectPlan';
import { Addons } from './components/Addons';
import { ServiceSummary } from './components/serviceSummary';
import { ThankYou } from './components/ThankYou';
import {Toaster} from 'react-hot-toast';
import { toast } from 'react-hot-toast';
import { api } from './lib/api.js';

function App() {
	const [step, setStep] = useState(1);
	const [showRequired, setShowRequiredFields] = useState(false);

  const [data,setData]=useState({
    battery_composition: {
        F: 0,
        Co: 0,
        Al: 0,
        P: 0,
        Li:0,
        S: 0,
        Ti: 0,
        Ni: 0,
        Fe:0
    },
    battery_data: {
        index: 0,
        name: "My battery",
        cathode_pot_min: 3.2,
        cathode_pot_average: 3.3,
        cathode_pot_max: 3.4,
        anode_material: "Graphite",
        battery_volt_min: 3.1,
        anode_pot: 0.2,
        battery_volt_average: 3.2,
        battery_volt_max: 3.3,
        cathode_capacity_min: 170,
        cathode_capacity_average: 175,
        cathode_capacity_max: 180,
        anode_capacity_min: 220,
        anode_capacity_average: 310,
        anode_capacity_max: 350,
        battery_energy_min: 550,
        battery_energy_average: 620,
        battery_energy_max: 670
    },
    objective_percentage: 100
});



  const [result,setResult]=useState(undefined)



	const [userServiceConfiguration, setUserServiceConfiguration] =
		useState<UserServiceConfiguration>({
			userInfo: {
				name: '',
				email: '',
				phone: '',
			},
			selectedPlan: null,
			monthly: true,
			addons: [],
		});

	const updateUserInfo = (userInfo: UserInfo) => {
		setUserServiceConfiguration({ ...userServiceConfiguration, userInfo });
	};

	const updateSelectedPlan = (plan: Plan) => {
		setUserServiceConfiguration({
			...userServiceConfiguration,
			selectedPlan: plan,
		});
	};

	const updateMonthly = () => {
		setUserServiceConfiguration((prevVal) => ({
			...userServiceConfiguration,
			monthly: !prevVal.monthly,
		}));
	};

	const updateAddons = (addon: Addon) => {
		const addons = userServiceConfiguration.addons;
		const index = addons.findIndex(
			(currentAddon) => currentAddon.name === addon.name
		);
		if (index === -1) {
			setUserServiceConfiguration({
				...userServiceConfiguration,
				addons: [...addons, addon],
			});
		} else {
			addons.splice(index, 1);
			setUserServiceConfiguration({
				...userServiceConfiguration,
				addons: [...addons],
			});
		}
	};

	const nextStep = (onGoingStep?: number) => {
		if (step === 5) return;
		if (step === 1 || (onGoingStep && onGoingStep !== 1 && step === 1)) {
      // check if battery composition are all of thenm 0 than error toast
      let sum=0;
      for (const [key, value] of Object.entries(data.battery_composition)) {
        sum+=Number(value);
      }
      if(sum===0){
        toast.error('Please fill the battery composition');
        return;
      }


		}

    if(step===3){
      handleSubmit()
    }
		setStep((step) => {
			if (onGoingStep) return onGoingStep;
			return step + 1;
		});
	};

	const goBack = () => {
		if (step === 1) return;
		setStep((step) => step - 1);
	};


  const handleSubmit=async()=>{

    const response=await api.post('/heraws',data).then(
      (response)=>{

        setResult(response.data)
      }
    ).catch(
      (error)=>{
        console.log(error)
        toast.error(
          'Something went wrong please try again later'
        );
      }
    )
  }

	return (
		<main className="h-screen flex flex-col text-neutral-cool-gray w-full lg:mx-auto lg:max-w-[58.75rem] lg:mt-10 lg:flex-row grow lg:p-4 lg:rounded-lg lg:bg-white lg:h-[40rem] lg:shadow" >
      <Toaster
  position="top-center"
  reverseOrder={false}
/>

{step < 4 && (
			<Sidebar currentStep={step} handleNextStep={nextStep} />
          )}
			<div className="px-4 relative bg-neutral-magnolia  lg:bg-transparent lg:flex lg:flex-col lg:w-full ">
				<form className="bg-neutral-alabaster px-6 py-9 rounded-[0.625rem] -translate-y-[4.5rem] flex w-full grow [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-primary-marine-blue [&_h3]:font-medium [&_h3]:text-primary-marine-blue lg:bg-transparent lg:translate-y-0 ">
					{step === 1 && (

						<PersonalInfo
            data={data}
            setData={setData}
							userInfo={userServiceConfiguration.userInfo}
							updateUserInfo={updateUserInfo}
							showRequired={showRequired}
						/>

					)}
					{step === 2 && (
						<SelectPlan
							selectedPlan={userServiceConfiguration.selectedPlan}
							monthly={userServiceConfiguration.monthly}
							updateSelectedPlan={updateSelectedPlan}
							updateIsMonthly={updateMonthly}
						/>
					)}
					{step === 3 && (
						<Addons
            data={data}
            setData={setData}
							selectedAddons={userServiceConfiguration.addons}
							monthly={userServiceConfiguration.monthly}
							updateAddons={updateAddons}
						/>
					)}

					{step === 4 && <ThankYou result={result}/>}
				</form>
				{step < 4 && (
					<menu className="flex justify-between p-4 mt-auto">
						<li>
						<button
            onClick={goBack}
            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
  Back
</button>
						</li>
						<li>
							<Button
								onClick={() => nextStep()}
								type={step !== 3 ? 'secondary' : 'primary'}
							>
								{step !== 3 ? 'Next Step' : 'Confirm'}
							</Button>
						</li>
					</menu>
				)}
			</div>
		</main>
	);
}

export default App;
